
import { useSelector } from 'react-redux'
// Chakra imports
import {
  Box,
  Icon,
  SimpleGrid,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import React from "react";
import {
  MdAdd,
  MdBarChart,
  MdStar,
  MdStarHalf,
} from "react-icons/md";
import PieCard, { } from "views/admin/default/components/PieCard";
import DevelopmentTable from "views/admin/default/components/DevelopmentTable";
import { 
  columnsDataDevelopment 
} from "views/admin/default/variables/columnsData";

export default function UserReports() {
  const pullsCount = useSelector(state => state.pulls.count)
  const pullsPity = useSelector(state => state.pulls.countPitySSR)
  const pullsHistory = useSelector(state => state.pulls.history)
  const chanceSSR = useSelector(state => state.pulls.chanceSSR)
  const chanceSR = useSelector(state => state.pulls.chanceSR)
  const targetPity = useSelector(state => state.pulls.targetPitySSR)

  // Chakra Color Mode
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        columns={{ base: 2, md: 4, lg: 4, "2xl": 4 }}
        gap='20px'
        mb='20px'>
        <MiniStatistics
          startContent={
            <IconBox
              w='56px'
              h='56px'
              bg={boxBg}
              icon={
                <Icon w='32px' h='32px' as={MdBarChart} color={brandColor} />
              }
            />
          }
          name='Total'
          value={pullsCount}
        />
        <MiniStatistics
          startContent={
            <IconBox
              w='56px'
              h='56px'
              bg={boxBg}
              icon={
                <Icon w='32px' h='32px' as={MdAdd} color={brandColor} />
              }
            />
          }
          name='Guarantee'
          value={pullsPity + " / " + targetPity}
        />
        <MiniStatistics
          startContent={
            <IconBox
              w='56px'
              h='56px'
              bg={boxBg}
              icon={
                <Icon w='32px' h='32px' as={MdStar} color={brandColor} />
              }
            />
          }
          name='SSR Chance'
          value={chanceSSR / 10 + ' %'}
        />
        <MiniStatistics 
          startContent={
            <IconBox
              w='56px'
              h='56px'
              bg={boxBg}
              icon={
                <Icon w='32px' h='32px' as={MdStarHalf} color={brandColor} />
              }
            />
          }
          name='SR Chance' 
          value={chanceSR / 10 + ' %'}
        />
      </SimpleGrid>

      <SimpleGrid columns={{ base: 1, md: 1, xl: 2 }} gap='20px' mb='20px'>
        <DevelopmentTable
          columnsData={columnsDataDevelopment}
          tableData={pullsHistory}
        />
        <PieCard />
      </SimpleGrid>

    </Box>
  );
}
